import React, { useEffect, useState, useContext } from "react";
import "./collect.css";
import moment from "moment";
import { AuthContext } from "../../ContextApi/ContextApi";
import { fetchAccountsFromApi, saveAccountData, fetchAccountDetails, fetchAccountFallback } from "./services/accountService";
import { clearExceptAccountNoFn, resetFormFn } from "./utils/formUtils";
import CollectForm from "./CollectForm";
import CollectSuggestions from "./CollectSuggestions";
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Navbar from "../../shared/Navbar";

export default function Collect() {
  const {firstName:firstName, userName: agentUserName } = useContext(AuthContext);
  const navigation = useNavigate();
  // States
  const [accountNo, setAccountNo] = useState("");
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [agentName, setAgentName] = useState("");
  const [accountType, setAccountType] = useState("");
  const [previousBalance, setPreviousBalance] = useState("");
  const [openDate, setOpenDate] = useState("");
  const [recieved, setRecieved] = useState("");
  const [presentBalance, setPresentBalance] = useState("");
  const [isView, setIsView] = useState("false");
  const [isSave, setIsSave] = useState("false");
  const [fieldsLocked, setFieldsLocked] = useState(false);
  const [allAccounts, setAllAccounts] = useState([]);
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    const loadAccounts = async () => {
      const accounts = await fetchAccountsFromApi(agentUserName);
      setAllAccounts(accounts);
    };
    loadAccounts();
    resetFormFn(setAccountNo, () => clearExceptAccountNoFn(setters));
  }, [agentUserName]);

  const setters = { setAccountNo,setName, setAccountType, setPreviousBalance, setOpenDate, setMobile, setAgentName, setRecieved, setPresentBalance, setIsSave, setIsView, setFieldsLocked };

  const clearExceptAccountNo = () => clearExceptAccountNoFn(setters);

  const saveData = async () => {
    if (!recieved || !presentBalance) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please enter Recieved amount and Add it',
      });
      return;
    }
    
    const data = {
      AccountNo: parseInt(accountNo),
      AccountType: accountType,
      Name: name,
      PreviousBalance: parseInt(previousBalance),
      PresentBalance: parseInt(presentBalance),
      OpenDate: openDate,
      Today: moment().format("DD-MM-YYYY"),
      AgentName: agentName,
      Mobile: mobile,
      Time: moment().format("HH:mm"),
      Recieved: parseInt(recieved)
    };
    
    try {
      await saveAccountData(data);
      await Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Amount Added successfully',
        timer: 2000,
        showConfirmButton: false
      });
      setIsSave("true");
      setIsView("false");
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to save data',
      });
    }
  };

  const handleAccountInput = (e) => {
    const value = e.target.value;
    setAccountNo(value);
    if (value.trim()) {
      let matches = allAccounts.filter(
        acc => acc.AccountNo.toString().includes(value) || acc.Name?.toLowerCase().includes(value.toLowerCase())
      );
      matches = matches.filter((acc, i, self) => i === self.findIndex(a => a.AccountNo === acc.AccountNo));
      // console.log("Matches found:", matches);
      matches.sort((a, b) => (a.AccountNo.toString().startsWith(value) ? -1 : 1) - (b.AccountNo.toString().startsWith(value) ? -1 : 1));
      // console.log("Sorted matches:", matches);
      setFilteredAccounts(matches);
      setShowSuggestions(matches.length > 0);
    } else setShowSuggestions(false);
  };

  const selectAccountSuggestion = async (account) => {
    setAccountNo(account.AccountNo);
    setShowSuggestions(false);
    await getAccountDetails(account.AccountNo);
  };

  // const getAccountDetails = async (accNoParam) => {
  //   const accNoToFetch = accNoParam || accountNo;
  //   if (!accNoToFetch) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error',
  //       text: 'Please enter Account No',
  //     });
  //     return;
  //   }
    
  //   try {
  //     let readSave = await fetchAccountDetails(accNoToFetch);
  //     console.log("Primary response:", readSave);
  //     if (readSave === "Account doesnt exist in database" || !readSave.length) {
  //       let jsonArray = await fetchAccountFallback(accNoToFetch);
  //       let json = jsonArray[0];
  //       if (json?.AgentName === agentUserName) {
  //         setAccountDetails(json, json.PreviousBalance);
  //       } else {
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Error',
  //           text: 'Account doesn\'t belong to you',
  //         });
  //         clearExceptAccountNo();
  //       }
  //     } else {
  //       let latest = readSave.filter(e => e.AccountNo == accNoToFetch).slice(-1)[0];
  //       if (latest?.AgentName === agentUserName) {
  //         setAccountDetails(latest, latest.PresentBalance);
  //       } else {
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Error',
  //           text: 'This Account doesn\'t belong to you',
  //         });
  //         clearExceptAccountNo();
  //       }
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Error',
  //       text: 'Failed to fetch account details',
  //     });
  //   }
  // };

  // 🔹 Helper: get latest entry for given account & agent
const getLatestEntry = (records, accNoToFetch, agentUserName) => {
  if (!records || !records.length) return null;

  // Keep only this agent’s records for this account
  const agentEntries = records.filter(
    e => e.AccountNo == accNoToFetch && e.AgentName === agentUserName
  );
console.log("Filtered agent entries:", agentEntries);
  if (!agentEntries.length) return null;

  // Sort descending by id → latest on top
  return agentEntries.sort((a, b) => b.id - a.id)[0];
};

const getAccountDetails = async (accNoParam) => {
  const accNoToFetch = accNoParam || accountNo;
  if (!accNoToFetch) {
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Please enter Account No',
    });
    return;
  }

  try {
    let readSave = await fetchAccountDetails(accNoToFetch, agentUserName);
    console.log("Primary response:", readSave);

    let latest;

    if (readSave === "Account doesnt exist in database" || !readSave.length) {
      // --- Fallback ---
      let jsonArray = await fetchAccountFallback(accNoToFetch);
      console.log("Fallback response:", jsonArray);

      latest = getLatestEntry(jsonArray, accNoToFetch, agentUserName);

      if (latest) {
        setAccountDetails(latest, latest.PreviousBalance);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Account doesn\'t belong to you',
        });
        clearExceptAccountNo();
      }
    } else {
      // --- Primary response ---
      latest = getLatestEntry(readSave, accNoToFetch, agentUserName);
      console.log("Latest entry found:", latest);
      if (latest) {
        setAccountDetails(latest, latest.PresentBalance);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'This Account doesn\'t belong to you',
        });
        clearExceptAccountNo();
      }
    }
  } catch (error) {
    console.error("Fetch error:", error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Failed to fetch account details',
    });
  }
};

  const setAccountDetails = (accData, balance) => {
    setIsView("true"); 
    setIsSave("false");
    setName(accData?.Name || "");
    setAccountType(accData?.AccountType || "");
    setPreviousBalance(balance || "0");
    setOpenDate(accData?.OpenDate || "");
    setMobile(accData?.Phone || "");
    setAgentName(accData?.AgentName || "");
    setRecieved(""); 
    setPresentBalance(""); 
    setFieldsLocked(true);
  };

  const addAmounts = () => setPresentBalance((parseInt(recieved || 0) + parseInt(previousBalance || 0)).toString());
  
  const sendSMS = () => {
    if (!recieved || !accountNo || !name) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please enter Account No and received Value',
      });
    } else {
      navigation("/Sms", {
        state: {
          firstName: firstName.toString(),
          Name: name.toString(),
          AccountNo: accountNo,
          AccountType: accountType.toString(),
          Recieved: recieved.toString(),
          PresentBalance: presentBalance.toString(),
          Phone: mobile,
          agentUserName: agentUserName
        }
      });
    }
  };
const printReceipt = () => {
 navigation("/BluetoothTest", {
        state: {
          firstName: firstName.toString(),
          Name: name.toString(),
          AccountNo: accountNo,
          AccountType: accountType.toString(),
          Recieved: recieved.toString(),
          PresentBalance: presentBalance.toString(),
          Phone: mobile,
          agentUserName: agentUserName
        }
      });
};
  return (
    <div>
      <Navbar />

    <div className="Collect-container">
      <h2 className="Collect-title">Collection</h2>
      <div className="Collect-row" style={{ position: "relative" }}>
        <input 
          className="Collect-input" 
          value={accountNo} 
          onChange={handleAccountInput} 
          placeholder="Account No or Name" 
          type="text" 
          disabled={fieldsLocked} 
        />
        {showSuggestions && (
          <CollectSuggestions 
            suggestions={filteredAccounts} 
            onSelect={selectAccountSuggestion} 
          />
        )}
      </div>
      {isView === "true" && (
        <CollectForm 
          {...{ 
            name, setName, mobile, setMobile, accountType, 
            openDate, previousBalance, recieved, setRecieved, 
            addAmounts, presentBalance, clearExceptAccountNo, 
            saveData, fieldsLocked 
          }} 
        />
      )}
      {isSave === "true" && (
        <div>
          <input className="Collect-input" value={name} readOnly />
          <input 
            className="Collect-input"   
            value={Number(presentBalance || 0).toFixed(2)}  
            readOnly 
          />
          <div className="Collect-btn-row">
            <button className="Collect-btn" onClick={sendSMS}>SMS</button>
            <button className="Collect-btn" onClick={printReceipt}>PRINT</button>
            <button 
              className="Collect-btn Collect-btn-clear" 
              onClick={clearExceptAccountNo}
            >
              Clear
            </button>
          </div>
        </div>
      )}
    </div>
    </div>
  );
}